import { ApiError } from "../http.js";
import { apiBase } from "../appSession.js";

async function request(path, { method = "GET", body, token } = {}) {
  const headers = { accept: "application/json" };
  if (body !== undefined) headers["content-type"] = "application/json";
  if (token) headers.authorization = `Bearer ${token}`;

  const init = { method, headers, credentials: "include" };
  if (body !== undefined) init.body = JSON.stringify(body);

  let response;
  try {
    response = await fetch(`${apiBase()}${path}`, init);
  } catch {
    throw new ApiError("Could not reach the server.", { status: 0 });
  }

  let payload = null;
  try {
    payload = await response.json();
  } catch {
    payload = null;
  }

  if (!response.ok) {
    throw new ApiError(payload?.error || `${response.status} ${response.statusText}`, {
      status: response.status,
    });
  }
  return payload;
}

export const appApi = {
  exchange: (code) => request("/api/auth/exchange", { method: "POST", body: { code } }),
  logout: (token) => request("/api/auth/logout", { method: "POST", token }),
  me: (token) => request("/api/me", { token }),
  overview: (token) => request("/api/me/overview", { token }),
  expenses: (token, from, to) => request(`/api/me/expenses?from=${from}&to=${to}`, { token }),
  diet: (token, from, to) => request(`/api/me/diet?from=${from}&to=${to}`, { token }),
  tasks: (token, from, to) => request(`/api/me/tasks?from=${from}&to=${to}`, { token }),
};
